
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","stroke":"#000000","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}},[_c('path',{attrs:{"d":"M9.767 9.662C4.624 9.248.75 7.43.75 5.251c0-2.486 5.037-4.5 11.25-4.5s11.25 2.014 11.25 4.5c0 1.181-1.138 2.256-3 3.059M23.25 11.251v-6"}}),_c('path',{attrs:{"d":"M.75 5.251v6c0 1.85 2.792 3.439 6.782 4.131"}}),_c('path',{attrs:{"d":"M.75 11.251v6c0 2.179 3.874 4 9.017 4.411M10.5 15.751a5.25 5.25 0 1010.5 0 5.25 5.25 0 10-10.5 0zM23.25 23.251l-3.788-3.788"}})])])
          )
        }
      }
    